import { Routes } from '@angular/router';
import { confirmGuard } from './shared/guards/confirm.guard';
import { registrationGuard } from './shared/guards/registration.guard';

// Каждая страница подгружается отдельным чанком: в рамках одной сессии пользователь
// почти всегда попадает только на 1-2 из них (auth ИЛИ registration ИЛИ verify),
// так что нет смысла тянуть все четыре компонента (и их Taiga UI зависимости) в main.js.
export const routes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./pages/login/login.component').then((m) => m.LoginComponent),
    children: [
      {
        path: 'auth',
        loadComponent: () =>
          import('./pages/login/component/authorization/authorization.component').then(
            (m) => m.AuthorizationComponent,
          ),
      },
      {
        path: 'registration',
        canActivate: [registrationGuard],
        loadComponent: () =>
          import('./pages/login/component/registration/registration.component').then(
            (m) => m.RegistrationComponent,
          ),
      },
      {
        path: 'verify',
        canActivate: [confirmGuard],
        loadComponent: () =>
          import('./pages/login/component/verify/verify.component').then(
            (m) => m.VerifyComponent,
          ),
      },
      { path: '', redirectTo: '/login/auth', pathMatch: 'full' },
    ],
  },
  { path: '**', redirectTo: '/login' },
];
